export default {"src":"/_next/static/media/home-active.d3008d5d.svg","height":1005,"width":1005,"blurWidth":0,"blurHeight":0};